import React from 'react';
import { CheckCircle2, TrendingUp } from 'lucide-react';

const SAPSpecialty = ({ t }) => {
  return (
    <section className="sap-specialty-section">
      <div className="container">
        <div className="specialty-content">
          <h2 className="section-title-large">{t.specialty.title}</h2>
          <p className="specialty-description">{t.specialty.description}</p>
          
          <div className="specialty-grid">
            <div className="specialty-column">
              <h3 className="specialty-subtitle">{t.specialty.whatIDo}</h3>
              <ul className="specialty-list">
                {t.specialty.items.map((item, index) => (
                  <li key={index} className="specialty-item">
                    <CheckCircle2 size={20} className="specialty-icon" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            
            <div className="specialty-column">
              <h3 className="specialty-subtitle">{t.specialty.results}</h3>
              <ul className="specialty-list">
                {t.specialty.resultItems.map((item, index) => (
                  <li key={index} className="specialty-item">
                    <TrendingUp size={20} className="specialty-icon" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SAPSpecialty;